module.exports = function() {
  return new Worker(__webpack_public_path__ + "e859b40ac6540dd836a9.worker.js");
};